// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_v-2";
export var blackBorderOnHover = "_v-7";
export var cell = "_v-6";
export var cellContainer = "_v-3";
export var checked = "_v-8";
export var disabled = "_v-5";
export var featuredIconCellContainer = "_v-9";
export var featuredIconTextContainer = "_v-b";
export var featuredIconWrapper = "_v-a";
export var noBorder = "_v-c";
export var orangeSelectedRow = "_2y-3";
export var overflowableText = "_v-0";
export var overflowableTextContainer = "_v-1";
export var row = "_w-0";
export var rowCheckboxCell = "_v-4";
export var selectableTable = "_2y-2";